interface AdoptionPromoState {
  /** Whether the shopper is an adopter with the programme switched on. */
  variantEnabled: boolean;
  /** The coupon currently attached to the cart. */
  couponCode: string | undefined;
  /** Whether pricing rejected that coupon. */
  hasCouponValidationError: boolean;
  /** The adopter's own alias, seeded on the coupon cookie by the rescue entry point. */
  adopterAlias: string | undefined;
}

/**
 * Whether the adoption discount is the one on the cart, and survived pricing.
 *
 * Three separate things have to hold, and dropping any of them credits the shelter for a discount
 * it did not give. The cookie only says the shopper is an adopter. A priced coupon only says some
 * coupon applied - a shopper whose adoption code failed can end up carrying the site-wide promo
 * instead, either by typing one or via `ShopPromotionBanner`, which falls back to it when the
 * cookie coupon fails. So the code on the cart must also be the adopter's own alias.
 *
 * Compared case-insensitively: recurly redeems codes without regard to case, so the cart can hold a
 * different casing of the same code than the cookie does.
 */
export function isAdoptionPromoApplied({
  variantEnabled,
  couponCode,
  hasCouponValidationError,
  adopterAlias,
}: AdoptionPromoState): boolean {
  if (!variantEnabled || !couponCode || hasCouponValidationError || !adopterAlias) {
    return false;
  }

  return couponCode.toLowerCase() === adopterAlias.toLowerCase();
}
